<template>
  <el-dialog title="Configurar E-mails de pesquisa de satisfação" :visible.sync="isVisible" @open="open" :before-close="fechar" :click-on-click-modal="false" append-to-body v-loading="isLoading" width="35%">
    
    <el-row :gutter="20">
      <el-checkbox v-model="parametros.emailPesquisaSeteDias">Após 7 dias.</el-checkbox>
      <el-input v-if="parametros.emailPesquisaSeteDias" v-model="parametros.linkEmailPesquisaSeteDias"></el-input>
    </el-row>
 
    <el-row :gutter="20">
      <el-checkbox v-model="parametros.emailPesquisaQuatroMeses">Após 4 meses.</el-checkbox>
      <el-input v-if="parametros.emailPesquisaQuatroMeses" v-model="parametros.linkEmailPesquisaQuatroMeses"></el-input>
    </el-row>

    <el-row :gutter="20">
      <el-checkbox v-model="parametros.emailPesquisaSeisMeses">Após 6 meses</el-checkbox>
      <el-input v-if="parametros.emailPesquisaSeisMeses" v-model="parametros.linkEmailPesquisaSeisMeses"></el-input>
    </el-row>

    <el-row :gutter="20">
      <el-checkbox v-model="parametros.emailPesquisaFinalContrato">Após final de contrato.</el-checkbox>
      <el-input v-if="parametros.emailPesquisaFinalContrato" v-model="parametros.linkEmailPesquisaFinalContrato"></el-input>
    </el-row>

    <span slot="footer">
      <el-button @click="gravarParametrosHandler" type="success" size="small" round class="btn-box-shadow">
        <i class="el-icon-check"/>
        Concluir
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      form: {
      }
    }
  },

  computed: {
    ...mapState({
      isLoading(state) { return state.loading },
    }),

    ...mapState('parametrosStore', {
      parametros(state) { return state.parametros },
    }),
  },

  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('parametrosStore', [
      'gravarParametros',
    ]),

    open() {

    },

    fechar() {
      this.$emit('close');
    },

    gravarParametrosHandler() {
      this.showLoading();

      this.gravarParametros(this.parametros)
      .then(response => {
        switch (response) {
          case "ERRO":
            this.$message.error(response.mensagem);
            break;
          case "SUCESSO":
            this.$message.success(response.mensagem);
            break;
        }
      }).catch(() => {
        this.$message.error("Não foi possível conectar-se ao servidor");
      }).finally(() => {
        this.hideLoading();
        this.fechar();
      })
    }
  }
}
</script>